import React from 'react';
import TagElement from '../../../../../../element/tags/TagElement';
import Button from '../../../../../../components/buttons/Button';
import Icon from '../../../../../../components/icons/Icon';
import { Tag } from '../../../../../../../common/tags/tagTypes';

type TagsListElementProps = {
    tag: Tag;
    handleClickTag: (tag: Tag) => void;
    handleClickEdit: (tag: Tag) => void;
    isSelected?: boolean;
    retreivingElementsForTag: string | null;
};

const TagsListElement: React.FC<TagsListElementProps> = ({
    tag,
    handleClickTag,
    handleClickEdit,
    isSelected,
    retreivingElementsForTag,
}) => {
    const { id, name, color } = tag;

    return (
        <div id={`tag-${id}`} className={`TagsListElement mb-1`}>
            <div className="w-full flex items-center justify-between">
                <TagElement name={name} color={color} size={'sm'} onClick={() => handleClickTag(tag)} />
                {isSelected ? (
                    <Icon name="block-style-tick" />
                ) : (
                    <Button disabled={retreivingElementsForTag === tag.id} onClick={() => handleClickEdit(tag)}>
                        ...
                    </Button>
                )}
            </div>
        </div>
    );
};

export default TagsListElement;
